import BaseApi from './BaseApi';

/**
 * アカウント発行API。
 */
class CreateCompanyStaffAccountApi extends BaseApi {
  async create(params: { name?: string; email: string }) {
    return await this.execute('createCompanyStaffAccountApi', {
      method: 'POST',
      body: {
        displayName: params.name || '',
        email: params.email
      }
    }).then(({ status, errorCode }) => ({ status, errorCode }));
  }
}

export default CreateCompanyStaffAccountApi;
